import React, { FC } from 'react';

import { Loader } from 'common/components';
import { getShowLoader } from 'common/redux/app-state/appState.selector';
import { RootState } from 'common/redux/core/root.reducer';
import { useSelector } from 'react-redux';

const Login: FC = () => {
    const isLoaderVisible = useSelector((state: RootState) => getShowLoader(state));
    return <Loader isVisible={!!isLoaderVisible} />;
};

export default Login;
